import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;



// ==========================================
// Create Quote
// ==========================================

export const createQuoteAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"));

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(
      `${apiBaseUrl}/createQuote`,
      payload,
      {
        headers,
      }
    );

    return response;

  } catch (error) {

    console.error("Error Creating Quote:", error);

    throw error;

  }
};



// ==========================================
// Get Quotes
// ==========================================

export const getQuotesAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"));

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(
      `${apiBaseUrl}/getQuotes`,
      payload,
      {
        headers,
      }
    );

    return response;

  } catch (error) {

    console.error("Error Getting Quotes:", error);

    throw error;

  }
};



// ==========================================
// View Quote
// ==========================================

export const getQuoteAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"));

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(
      `${apiBaseUrl}/viewQuote`,
      payload,
      {
        headers,
      }
    );

    return response;

  } catch (error) {

    console.error("Error Viewing Quote:", error);

    throw error;

  }
};



// ==========================================
// Update Quote
// ==========================================

export const updateQuoteAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"));

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(
      `${apiBaseUrl}/updateQuote`,
      payload,
      {
        headers,
      }
    );

    return response;

  } catch (error) {

    console.error("Error Updating Quote:", error);

    throw error;

  }
};



// ==========================================
// Change Quote Status
// ==========================================

export const changeQuoteStatusAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"));

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(
      `${apiBaseUrl}/changeQuoteStatus`,
      payload,
      {
        headers,
      }
    );

    return response;

  } catch (error) {

    console.error("Error Changing Quote Status:", error);

    throw error;

  }
};



// ==========================================
// Generate Quote PDF
// ==========================================

export const generateQuotePdfAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"));

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(
      `${apiBaseUrl}/generateQuotePdf`,
      payload,
      {
        headers,
      }
    );

    return response;

  } catch (error) {

    console.error("Error Generating Quote PDF:", error);

    throw error;

  }
};